import { createSelector } from '@reduxjs/toolkit';
import { settingsPageSelectors } from '@/Pages/Settings/services/selectors';
import { DocumentTemplateSettingsState } from './reducer';

const templates = createSelector(
  settingsPageSelectors.documentTemplateSettings,
  (state: DocumentTemplateSettingsState) => state.templates,
);

const templateOptions = createSelector(
  settingsPageSelectors.documentTemplateSettings,
  (state: DocumentTemplateSettingsState) => {
    return state.templates.map((item) => ({ key: item.guid, value: item.name }));
  },
);

const selectedTemplate = createSelector(
  settingsPageSelectors.documentTemplateSettings,
  (state: DocumentTemplateSettingsState) => state.selectedTemplate,
);

const printers = createSelector(
  settingsPageSelectors.documentTemplateSettings,
  (state: DocumentTemplateSettingsState) => state.printers,
);

const selectedPrinterName = createSelector(
  settingsPageSelectors.documentTemplateSettings,
  (state: DocumentTemplateSettingsState) => state.selectedPrinterName ?? '',
);

const isPrintPreview = createSelector(
  settingsPageSelectors.documentTemplateSettings,
  (state: DocumentTemplateSettingsState) => state.isPrintPreview,
);

const templateModal = createSelector(
  settingsPageSelectors.documentTemplateSettings,
  (state: DocumentTemplateSettingsState) => state.templateModal,
);

const defaultPrinter = createSelector(settingsPageSelectors.documentTemplateSettings, (state) => {
  return state.defaultPrinter;
});

export const documentTemplateSettingsSelectors = {
  templates,
  templateOptions,
  selectedTemplate,
  printers,
  selectedPrinterName,
  isPrintPreview,
  defaultPrinter,
  templateModal,
};
